var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ghost",style:(_vm.style)},[_c(_vm.component,_vm._b({tag:"component"},'component',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }